import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Heart, Facebook } from "lucide-react";
import { ASSETS, CLINIC } from "../lib/api";
import { useCookieConsent } from "../contexts/CookieConsentContext";

export default function Footer() {
  const year = new Date().getFullYear();
  const { reopenPreferences } = useCookieConsent();
  return (
    <footer className="relative overflow-hidden bg-brand-navy text-white mt-24" data-testid="site-footer">
      <div
        aria-hidden
        className="pointer-events-none absolute right-0 top-0 w-72 h-72 opacity-10"
        style={{ backgroundImage: `url(${ASSETS.emblem})`, backgroundSize: 'cover', borderRadius: '999px', transform: 'translate(30%,-30%)' }}
      />
      <div className="max-w-7xl mx-auto container-x py-14 grid md:grid-cols-3 gap-10 relative">
        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center rounded-full bg-brand-yellow w-14 h-14 overflow-hidden ring-4 ring-white/10">
              <img src={ASSETS.emblem} alt="" className="w-full h-full object-cover scale-110" draggable={false} />
            </span>
            <div>
              <div className="font-display font-extrabold text-xl leading-tight">Ro-Dental Cluj-Napoca</div>
              <div className="text-brand-yellow text-sm font-semibold">CMI. Dr. Biriș Cornelia</div>
            </div>
          </div>
          <p className="mt-5 text-white/80 text-sm leading-relaxed max-w-sm">
            <em>„{CLINIC.slogan}"</em><br/>
            {CLINIC.doctor} — {CLINIC.doctorTitle}, cu o experiență de peste 25 de ani.
          </p>
        </div>

        <div>
          <h3 className="text-white font-display font-bold text-lg mb-4">Contact</h3>
          <ul className="space-y-3 text-sm text-white/85">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-brand-yellow shrink-0"/>{CLINIC.address}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-brand-yellow shrink-0"/>
              <a href={CLINIC.phoneTel} className="hover:underline" data-testid="footer-phone">{CLINIC.phonePretty}</a>
            </li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-brand-yellow shrink-0"/>
              <a href={`mailto:${CLINIC.email}`} className="hover:underline">{CLINIC.email}</a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-display font-bold text-lg mb-4">Navigare</h3>
          <ul className="space-y-2 text-sm text-white/85">
            <li><Link to="/despre" className="hover:underline">Despre medic</Link></li>
            <li><Link to="/servicii" className="hover:underline">Servicii</Link></li>
            <li><Link to="/programare" className="hover:underline">Programare</Link></li>
            <li><Link to="/contact" className="hover:underline">Contact</Link></li>
          </ul>

          <div className="mt-5 flex items-center gap-2 flex-wrap">
            <a
              href={CLINIC.googleReviewUrl}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-brand-yellow text-brand-navy text-xs font-bold hover:bg-yellow-300"
              data-testid="footer-google-review"
            >★ Recenzie Google</a>
            <a
              href={`https://wa.me/40721592343`}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-brand-green text-white text-xs font-semibold hover:opacity-90"
              data-testid="footer-whatsapp"
            >WhatsApp</a>
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https://ro-dental.ro"
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-white/10 text-white text-xs font-semibold hover:bg-white/20"
              data-testid="footer-facebook"
            ><Facebook className="w-3.5 h-3.5"/> Distribuie</a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto container-x py-5 flex flex-col gap-3 text-xs text-white/60">
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-2" data-testid="footer-gdpr-links">
            <Link to="/informare-gdpr" className="hover:text-brand-yellow underline underline-offset-2" data-testid="footer-link-gdpr">Informare GDPR pentru pacienți</Link>
            <span aria-hidden className="opacity-40">·</span>
            <Link to="/politica-confidentialitate" className="hover:text-brand-yellow underline underline-offset-2" data-testid="footer-link-privacy">Politica de confidențialitate</Link>
            <span aria-hidden className="opacity-40">·</span>
            <Link to="/politica-cookies" className="hover:text-brand-yellow underline underline-offset-2" data-testid="footer-link-cookies">Politica de cookies</Link>
            <span aria-hidden className="opacity-40">·</span>
            <button type="button" onClick={reopenPreferences} className="hover:text-brand-yellow underline underline-offset-2" data-testid="footer-link-cookie-preferences">Preferințe cookies</button>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2 border-t border-white/5">
            <div>© {year} {CLINIC.legalName} · Ro-Dental Cluj-Napoca. Toate drepturile rezervate.</div>
            <div className="flex items-center gap-1.5"><Heart className="w-3.5 h-3.5 text-brand-pink"/> Sănătatea dumneavoastră orală, prioritatea noastră.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
